<!--
 * @Description: 工作任务 日常工作 详情
 * @Author: PF
 * @Date: 2023-03-22 19:04:23
 * @LastEditors: PF
 * @LastEditTime: 2024-02-05 11:25:34
-->
<template>
  <div>
    <el-dialog class="w800 hp80" :model-value="openWanCheng" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openWanCheng', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
        <el-descriptions :column="4" border class="descript-box">
          <el-descriptions-item label="工作任务标题" label-align="right" align="left" width="130px" span="2">{{ruleForm.gzrwbt}}</el-descriptions-item>
          <el-descriptions-item label="工作类别" label-align="right" align="left" width="130px" span="2">{{ruleForm.gzlbmc}}</el-descriptions-item>
          <el-descriptions-item label="日常工作" label-align="right" align="left" span="2">{{ruleForm.gzrwbt}}</el-descriptions-item>
          <el-descriptions-item label="日常工作" label-align="right" align="left" span="2">{{ruleForm.gzrwbt}}</el-descriptions-item>
          <el-descriptions-item label="待办内容" label-align="right" align="left" span="2">{{ruleForm.dbnr}}</el-descriptions-item>
          <el-descriptions-item label="开始时间" label-align="right" align="left" span="2">{{ruleForm.kssj}}</el-descriptions-item>
          <el-descriptions-item label="完成时间" label-align="right" align="left" span="2">{{ruleForm.wcsj}}</el-descriptions-item>
          <el-descriptions-item label="工作总结" label-align="right" align="left" span="4">
            <p v-if="ruleForm.gzzj" style="white-space: pre-wrap; text-indent:0;" v-html="ruleForm.gzzj.gzzj"></p>
          </el-descriptions-item>
          <el-descriptions-item label="" label-align="right" align="left" span="4"></el-descriptions-item>
        </el-descriptions>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="info" @click="closeWindow('openWanCheng', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch } from 'vue'
import { closeWindow, loadData } from '@/api/common.js'

const props = defineProps({
  openWanCheng: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openWanCheng', 'ReturnData'])

const ruleForm = ref({})

watch(
  () => props.openWanCheng,
  () => {
    if (props.openWanCheng) {
      // loadData({
      //   url: '/api/v2/bangong/bangongdaibanshixiang/bangong/' + props.row.id,
      //   ruleForm,
      //   loadSuccess: function () {
      //   }
      // })
    }
  },
  { deep: true, immediate: true }
)
</script>
